/* Opens a url in the in-app Safari sheet; `onFinished` runs once the user closes it. */
export const openInNativeBrowser = async ({
  url,
  onFinished,
}: {
  url: string;
  onFinished?: () => void;
}): Promise<void> => {
  const { Browser } = await import("@capacitor/browser");
  const listener = await Browser.addListener("browserFinished", () => {
    void listener.remove();
    onFinished?.();
  });
  try {
    await Browser.open({ url });
  } catch (error) {
    await listener.remove();
    throw error;
  }
};

/* Runs `onResume` whenever the app returns to the foreground; returns a cleanup. */
export const addNativeResumeListener = async (onResume: () => void): Promise<() => Promise<void>> => {
  const { App } = await import("@capacitor/app");
  const handle = await App.addListener("resume", onResume);
  return () => handle.remove();
};
